import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import StudentConcept from '../../components/views/student/Concept'
import TeacherConcept from '../../components/views/teacher/Concept'

/**
 * Dasselbe Konzept, zwei Rollen — und deshalb zwei Ansichten hinter einer
 * Adresse: Die Schüler:innen schreiben es, die betreuende Lehrkraft bewertet
 * es. Beide Ansichten fragen dieselbe Stelle im Server, nur mit anderen
 * Knöpfen.
 */
function ConceptPage(props) {
	if (props.role === TRoles.STUDENT) return <StudentConcept />
	if (props.role === TRoles.TEACHER) return <TeacherConcept />

	return <Redirect to={TRoutes.DASHBOARD} />
}

ConceptPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(ConceptPage)
